/*!
 * @Instruduction: AI 模型调用日志（模型运行日志）服务接口
 * 路径前缀：/api/ai/chat-log
 *
 * 注：本模块为"新规范"——入参/出参均透传后端驼峰（pageIndex/providerId 等），
 * 不做 camelToSnake 转换（区别于 provider/feature 老接口）。
 * 返回分页 key 为 page_total/page_index/page_size/list（后端 PageResult 固定蛇形）。
 */

import xhr from './xhr/index'
import { IChatLogListParams } from '@/types/ai-types'

const BASE = '/api/ai/chat-log'

class AiChatLogService {
    /** 模型调用日志分页列表：多条件搜索，返回 { page_total, page_index, page_size, list } */
    public async listChatLogs(params: IChatLogListParams) {
        const result = await xhr({
            method: 'get',
            url: `${BASE}/list`,
            params: params
        })
        return result
    }

    /** 模型调用日志详情（全量，含 prompt/response 大字段） */
    public async getChatLog(id: number) {
        const result = await xhr({
            method: 'get',
            url: `${BASE}/${id}`,
            params: {}
        })
        return result
    }
}

// 实例化后导出，全局单例
export default new AiChatLogService()
